var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1149_4875)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.658 3.663a8.5 8.5 0 00-10.115 7.483l.677-.676a.75.75 0 011.06 1.06l-1.823 1.824a1 1 0 01-1.414 0L.22 11.53a.75.75 0 111.06-1.06l.75.75A10 10 0 1112 22a.75.75 0 010-1.5 8.5 8.5 0 001.658-16.837zM12.75 6a.75.75 0 00-1.5 0v6.288l.193.214 4.5 5a.75.75 0 101.115-1.004l-4.308-4.786V6z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1149_4875"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}
SvgTransactionHistory.displayName = 'TransactionHistory';
export default SvgTransactionHistory;